export const AHREFS_DOMAIN_RATING_PROVIDER = "ahrefs" as const;
export const AHREFS_DOMAIN_RATING_ENDPOINT =
  "https://api.ahrefs.com/v3/public/domain-rating-free";
export const AHREFS_DOMAIN_RATING_SOURCE_URL =
  "https://ahrefs.com/website-authority-checker";
export const AHREFS_DOMAIN_RATING_ATTRIBUTION_URL = "https://ahrefs.com/";
export const AHREFS_DOMAIN_RATING_LICENSE_URL =
  "https://ahrefs.com/legal/domain-rating-license";
